"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatUTokenInteger = exports.formatTokenInteger = exports.formatUTokenDecimal2 = exports.formatLunaWithPostfixUnits = exports.formatLuna = exports.formatAUSTWithPostfixUnits = exports.formatAUST = exports.formatUSTWithPostfixUnits = exports.formatUST = exports.formatANCWithPostfixUnits = exports.formatLP = exports.formatANC = exports.formatLPInput = exports.formatANCInput = exports.formatLunaInput = exports.formatAUSTInput = exports.formatUSTInput = exports.ANC_INPUT_MAXIMUM_DECIMAL_POINTS = exports.ANC_INPUT_MAXIMUM_INTEGER_POINTS = exports.LUNA_INPUT_MAXIMUM_DECIMAL_POINTS = exports.LUNA_INPUT_MAXIMUM_INTEGER_POINTS = exports.AUST_INPUT_MAXIMUM_DECIMAL_POINTS = exports.AUST_INPUT_MAXIMUM_INTEGER_POINTS = exports.UST_INPUT_MAXIMUM_DECIMAL_POINTS = exports.UST_INPUT_MAXIMUM_INTEGER_POINTS = exports.iFormatter = exports.d6Formatter = exports.d6InputFormatter = exports.d3Formatter = exports.d3InputFormatter = exports.d2Formatter = exports.mapDecimalPointBaseSeparatedNumbers = void 0;
var big_js_1 = __importDefault(require("big.js"));
var currency_1 = require("./currency");
var unit_format_1 = require("./unit.format");
// ---------------------------------------------
// render
// ---------------------------------------------
function mapDecimalPointBaseSeparatedNumbers(n, mapper) {
    var _a = __read(n.toString().split('.'), 2), i = _a[0], d = _a[1];
    return mapper(i, d);
}
exports.mapDecimalPointBaseSeparatedNumbers = mapDecimalPointBaseSeparatedNumbers;
// ---------------------------------------------
// formatters
// ---------------------------------------------
exports.d2Formatter = unit_format_1.formatDemimal({ decimalPoints: 2, delimiter: true });
exports.d3InputFormatter = unit_format_1.formatDemimal({
    decimalPoints: 3,
    delimiter: false,
});
exports.d3Formatter = unit_format_1.formatDemimal({ decimalPoints: 3, delimiter: true });
exports.d6InputFormatter = unit_format_1.formatDemimal({
    decimalPoints: 6,
    delimiter: false,
});
exports.d6Formatter = unit_format_1.formatDemimal({ decimalPoints: 6, delimiter: true });
exports.iFormatter = unit_format_1.formatInteger({ delimiter: true });
// ---------------------------------------------
// constants
// ---------------------------------------------
exports.UST_INPUT_MAXIMUM_INTEGER_POINTS = 14;
exports.UST_INPUT_MAXIMUM_DECIMAL_POINTS = 3;
exports.AUST_INPUT_MAXIMUM_INTEGER_POINTS = 14;
exports.AUST_INPUT_MAXIMUM_DECIMAL_POINTS = 6;
exports.LUNA_INPUT_MAXIMUM_INTEGER_POINTS = 14;
exports.LUNA_INPUT_MAXIMUM_DECIMAL_POINTS = 6;
exports.ANC_INPUT_MAXIMUM_INTEGER_POINTS = 14;
exports.ANC_INPUT_MAXIMUM_DECIMAL_POINTS = 6;
var M = 1000000;
// ---------------------------------------------
// specific format functions
// ---------------------------------------------
function formatUSTInput(n) {
    return exports.d3InputFormatter(n);
}
exports.formatUSTInput = formatUSTInput;
function formatAUSTInput(n) {
    return exports.d6InputFormatter(n);
}
exports.formatAUSTInput = formatAUSTInput;
function formatLunaInput(n) {
    return exports.d6InputFormatter(n);
}
exports.formatLunaInput = formatLunaInput;
function formatANCInput(n) {
    return exports.d6InputFormatter(n);
}
exports.formatANCInput = formatANCInput;
function formatLPInput(n) {
    return exports.d6InputFormatter(n);
}
exports.formatLPInput = formatLPInput;
function formatANC(n) {
    return exports.d6Formatter(n);
}
exports.formatANC = formatANC;
function formatLP(n) {
    return exports.d6Formatter(n);
}
exports.formatLP = formatLP;
function formatANCWithPostfixUnits(n) {
    var bn = big_js_1.default(n);
    return bn.gte(M) ? exports.d3Formatter(bn.div(M)) + 'M' : formatANC(n);
}
exports.formatANCWithPostfixUnits = formatANCWithPostfixUnits;
function formatUST(n) {
    if (big_js_1.default(n).gt(0) && big_js_1.default(n).lt(0.001)) {
        return '<0.001';
    }
    return exports.d3Formatter(n);
}
exports.formatUST = formatUST;
function formatUSTWithPostfixUnits(n) {
    var bn = big_js_1.default(n);
    return bn.gte(M) ? exports.d2Formatter(bn.div(M)) + 'M' : formatUST(n);
}
exports.formatUSTWithPostfixUnits = formatUSTWithPostfixUnits;
function formatAUST(n) {
    return exports.d6Formatter(n);
}
exports.formatAUST = formatAUST;
function formatAUSTWithPostfixUnits(n) {
    var bn = big_js_1.default(n);
    return bn.gte(M) ? exports.d3Formatter(bn.div(M)) + 'M' : exports.d6Formatter(bn);
}
exports.formatAUSTWithPostfixUnits = formatAUSTWithPostfixUnits;
function formatLuna(n) {
    return exports.d6Formatter(n);
}
exports.formatLuna = formatLuna;
function formatLunaWithPostfixUnits(n) {
    var bn = big_js_1.default(n);
    return bn.gte(M) ? exports.d3Formatter(bn.div(M)) + 'M' : exports.d3Formatter(bn);
}
exports.formatLunaWithPostfixUnits = formatLunaWithPostfixUnits;
// ---------------------------------------------
// unspecific format functions
// ---------------------------------------------
function formatUTokenDecimal2(n) {
    var bn = big_js_1.default(n).div(currency_1.MICRO);
    return bn.gte(M) ? exports.d2Formatter(bn.div(M)) + 'M' : exports.d2Formatter(bn);
}
exports.formatUTokenDecimal2 = formatUTokenDecimal2;
function formatTokenInteger(n) {
    return big_js_1.default(n).gte(M) ? exports.iFormatter(n) + 'M' : exports.iFormatter(n);
}
exports.formatTokenInteger = formatTokenInteger;
function formatUTokenInteger(n) {
    var bn = big_js_1.default(n).div(currency_1.MICRO);
    return bn.gte(M) ? exports.iFormatter(bn.div(M)) + 'M' : exports.iFormatter(bn);
}
exports.formatUTokenInteger = formatUTokenInteger;
//# sourceMappingURL=currency.format.js.map